export const newProject = { name: '', description: '', files: [] };

export const newlyAddedProject = {
  name: '',
  description: '',
  filesUrl: [],
  files: [],
  visibility: 'public',
  isHiddenOnPublic: false,
  is_hidden_on_public: false,
};

export const newReference = {
  name: '',
  email: '',
  role: '',
  organization: '',
  phone: '',
};

export const newCertification = {
  name: '',
  date: '',
  file: null,
};

export const newlyAddedCertification = {
  name: '',
  date: '',
  filesUrl: [],
};

export const newAccomplishment = {
  name: '',
  date: '',
  description: '',
  links: [''],
  files: [],
};

export const newlyAddedAccomplishment = {
  name: '',
  date: '',
  description: '',
  links: [] as string[],
  filesUrl: [],
};

export const newOrganization = {
  name: '',
  startDate: '',
  endDate: '',
  description: '',
  link: '',
};
